import { gql } from '@apollo/client';
export default gql`
  query getHritems(
    $start: Date
    $end: Date
    $departmentId: String
    $employeeId: String
  ) {
    getHritems(
      start: $start
      end: $end
      departmentId: $departmentId
      employeeId: $employeeId
    ) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo

        opDocNo

        time

        bonosvalue
        bonosqty
        bonos
        overtimevalue
        overtimeqty
        overtime
        deductionvalue
        deductionqty
        deduction
        desc

        contractId
        contractName
        contractNameAr
        departmentId
        departmentName
        departmentNameAr
        employeeId
        employeeName
        employeeNameAr

        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
